import { Country } from "../services/api/types/graphql";

interface IPostcodeParts {
  incode: string;
  outcode: string;
}

/**
 * The length of the "inward code" part of a postcode. It's the last 3 characters,
 * one of the only things about postcodes that has a simple rule defining it.
 */
const INCODE_LENGTH = 3;

/**
 * Clean a postcode: remove non-alnum, uppercase
 * Exported so we can test it; not intended to be used outside.
 */
export const cleanPostcode = (postcode: string): string => {
  const regex = /[^A-Z0-9]/g;
  return postcode.toUpperCase().replace(regex, "");
};

/**
 * split a postcode into incode and outcode. incode is always three characters.
 * If we don't have enough characters, return undefined.
 * Exported so we can test it; not intended to be used outside.
 */
export const splitPostcode = (postcode: string): IPostcodeParts | undefined => {
  if (postcode.length <= INCODE_LENGTH) {
    return undefined;
  }
  const inOutSplitIndex = postcode.length - INCODE_LENGTH;

  return {
    incode: postcode.substr(inOutSplitIndex),
    outcode: postcode.substr(0, inOutSplitIndex),
  };
};

/**
 * Rudimentary postcode formatter
 * Exported so we can test it; not intended to be used outside.
 */
export const formatPostcodeParts = (post: IPostcodeParts): string => {
  return `${post.outcode} ${post.incode}`;
};

export const checkOutcode = (outcode: string) => {
  const regex = /^[A-Z]{1,2}[1-9][0-9A-Z]?$/;

  return outcode.match(regex);
};

export const deriveCountryFromPostcode = (postcode: string): Country => {
  const swissPostcodeRegex = /^\d{4}$/;

  if (swissPostcodeRegex.test(postcode)) {
    return Country.CH;
  }

  return Country.GB;
};
